import PropTypes from 'prop-types';
// material
import { Box, Typography } from '@mui/material';
// components
import PaymentIcon from './Icon';

PaymentMessage.propTypes = {
  payment: PropTypes.object
};

export default function PaymentMessage({ payment }) {
  return (
    <Box sx={{ textAlign: 'center' }} mb={2}>
      <PaymentIcon status={payment.status} />
      <Typography component="h2" variant="h5" gutterBottom>
        {payment.message}
      </Typography>
    </Box>
  );
}
